import React from 'react';
import { toast } from 'react-toastify'
import { connect } from 'react-redux';
import { Button } from 'reactstrap'
import { Auth } from 'aws-amplify';
import { DateTime } from 'luxon'
import { compose } from 'redux';

import {
	Link, withRouter
} from "react-router-dom";

import { toBase64, getImageSpecs, parseTheme } from '../../utils/common'
import { apiCall } from '../../utils/ApiUtils'
import SidePanelToggle from './Common/SidePanelToggle';
import NotificationItem from './Common/NotificationItem';
import { getNotificationsBySite, markNotificationAsRead } from '../../utils/Notifications';
import setting from '../../utils/Settings'
import { isAuthenticated, populateUser, revertToAdminSession, switchDarkMode } from '../../../features/session/sessionSlice';
import { appendModel, getNotifications, unReadNotifications } from '../../../features/site/siteSlice';

import logo from "../../../assets/images/insights-engine.png"
import logoWhite from "../../../assets/images/insights-engine-white.png"
import CheckoutButton from '../Stripe/CheckoutButton';

const INITIAL_STATE = {
	lastEvalKey: null,
	init: true,
	allLoaded: false,
	notifPanelActive: false,
	notifications: [],
	notificationsLoaded: true
}

class Header extends React.Component{
	toastId = null;

	constructor(props){
		super(props)

		this.state = {
			...INITIAL_STATE
		}
		this.inputFileRef = React.createRef();
		this.onNotificationClick = this.onNotificationClick.bind(this)
	}

	async onAvatarChange(e){
		e.persist()
		const { model, user, isAdmin, populateUser } = this.props

		const { filesize } = await getImageSpecs(e.target.files[0])

		if(filesize / 1000 > 200){
			toast.error("File size for avatars must not exceed 200 KB", {containerId: "defaultToastContainer"})
		} else {

			const logo = await toBase64(e.target.files[0])
			
			const { response, error } = await apiCall(`user/${user.userId}`,{
				method: 'PUT',
				body: {
					email: user.email, 
					siteId: isAdmin ? null : user.siteId,
					family_name: user.family_name,
					given_name: user.given_name,
					userId: user.userId,
					avatar: logo
				}
			})
			
			if(!error && !response.errorType){
				toast.success("Avatar successfully uploaded!", {containerId: "defaultToastContainer"})
				populateUser({
					...user,
					avatar: logo
				})
			}
		}
	}


    clickLogo($event){
        $event.preventDefault()
        window.location = '/'
	}

    async logout($event){
        $event.preventDefault()
		try {
			const dt = await Auth.signOut({ global: true })
		} catch(e){}
		localStorage.removeItem('token')
        window.location = '/'
	}
	
	async componentDidMount(){
		const theme = parseTheme()
		let newState = {
			theme
		}
		if(this.props.model?.sites && this.props.model.siteActiveIdx >= 0){

			if(!this?.props?.isAdmin){
				const site = this.props.model.sites[this.props.model.siteActiveIdx]
				await this.props.getNotificationsBySite({siteId: site.siteId})
			}

			newState.notificationsLoaded = true

			this.setState(prevState => ({
				...prevState,
				...newState
			}))
		} else {
			this.setState(prevState => ({
				...prevState,
				...newState
			}))
		}
	}

	async componentDidUpdate(prevProps, prevState){
		if(this.props.model?.sites && this.props.model.siteActiveIdx >= 0){
			const site = this.props.model.sites[this.props.model.siteActiveIdx]
			const prevSite = prevProps.model.sites[prevProps.model.siteActiveIdx]

			if(prevSite?.siteId !== site?.siteId && site !== undefined){
				await this.props.getNotificationsBySite({siteId: site.siteId})
			}
		}
	}


    async loadMoreNotifications() {
		const { token, $dataStorage } = this.state
		const { model, lastEvalKey } = this.props
		const site = model.sites[model.siteActiveIdx]
		await this.props.getNotificationsBySite({siteId: site.siteId, lastEvalKey})
	}
	
	async onNotificationClick(notificationId, link) {
		const { $dataStorage, token } = this.state
		const { model, user, isAdmin, notifications } = this.props
		let markAsRead = true

		let notifs = [...notifications]
		const key = [...notifs].findIndex(n => n.notificationId === notificationId)

		if(notifs[key].users){
			if(notifs[key].users[user.userId] && notifs[key].users[user.userId].read){
				markAsRead = false
			}
			notifs[key] = {
				...notifs[key],
				users: {
					...notifs[key].users,
					[user.userId]: {
						read: true
					}
				}
			}
		} else {
			notifs[key] = {
				...notifs[key],
				users:{
					[user.userId]: {
						read: true
					}
				}
			}	
		}
		if(markAsRead){
			await markNotificationAsRead(token,notificationId)
			await this.props.appendModel({
				notification: {
					...model.notification,
					items: notifs
				}
			})
		}


		if(link){
			this.props.history.push(link.replace("/app", ""))
		}
	}

	render(){
		const { user, model, isAdmin, trialMode, trialExpired, showAdminScreen, avatar, notifications, unReadMessages, useDarkMode, onboardingInProgress, adminSession } = this.props
		const { theme } = this.state
		
		let { allLoaded, notifPanelActive , notificationsLoaded} = this.state
		const site = model?.sites?.length > 0 ? model?.sites[model?.siteActiveIdx] : {}

		let trialExpiryDays = 0
		if(model.siteFixed && site && site.attr.trialExpiryDate){
			trialExpiryDays = Math.ceil(DateTime.fromISO(site.attr.trialExpiryDate).diffNow('days').days)
		}

		let headerStyle = {
			borderBottom: "2px solid #284699"
		}
		let logoClasses = "ml-sm-3 logo-styled"
		let navbarClasses = "navbar-header"

		let logoDir = logo

		if(theme){
			if(theme.mainLogo){
				logoDir = theme.mainLogo
			}
			if(theme.primaryColorHex){
				headerStyle.borderBottom = `2px solid ${theme.primaryColorHex}`
			}
		}

		if(useDarkMode){
			logoDir = logoWhite
		}

		const notificationItemList = (className, showMore=false) => notifications?.filter((v,k) => !showMore ? k < 6 : true ).map((n, key) => <NotificationItem className={className} {...n} onNotificationClick={this.onNotificationClick} />)
		

		return <div id="header" style={headerStyle} className="header navbar-default no-print">
			<div className={navbarClasses}>
				<a href="/" id="alt-logo" className={logoClasses} onClick={this.clickLogo}>
			  	  <img src={logoDir} style={{height: "55px", marginTop: "5px", marginLeft: "5px", minWidth: "140px"}} />
			    </a>
				{!onboardingInProgress && !setting.layout.pageTwoSidebar && !(setting.layout.pageTopMenu && setting.layout.pageWithoutSidebar) &&<button type="button" className="navbar-toggle" data-click="sidebar-toggled">
					<span className="icon-bar"></span>
					<span className="icon-bar"></span>
					<span className="icon-bar"></span>
				</button>}
			</div>
			
			<input ref={this.inputFileRef} type="file" className="hide" onChange={e => this.onAvatarChange(e)} />

			<ul className="navbar-nav navbar-right">
				{model.siteFixed && site && site.attr.trialExpiryDate && <>
					<li className="nav-item ml-3" style={{top:"10px"}}>
						<div className="alert alert-primary d-flex align-items-center pb-2 pt-2 pl-10 pr-10">
							<h5 className="text-primary mr-2 mb-0">
								{trialExpiryDays > 0 ? `Trial Ends in ${trialExpiryDays} days`: `You've extended past your 7 day trial period`}
							</h5>
							<CheckoutButton title="Subscribe Now" size="sm" overrideCancelUrl={"/overview"} siteId={site.siteId} />
						</div>
					</li>
				</>}
				{!onboardingInProgress && <li id="notificationBell" className="dropdown">
					<a href="javascript:;" data-toggle="dropdown" className="dropdown-toggle f-s-14">
						<i className="fa fa-bell" style={{fontSize: "1.5em"}}></i>
						{notificationsLoaded && unReadMessages > 0 && <span className="label">{unReadMessages}</span>}
					</a>
					<div className="dropdown-menu media-list dropdown-menu-right">
						<div className="dropdown-header">NOTIFICATIONS ({unReadMessages})</div>
						<>{notificationItemList("dropdown-item")}</>		
						<div className="dropdown-footer text-center">
							<Link to="/notifications">View more</Link>
						</div>
					</div>
				</li>}
				{!onboardingInProgress && <li className="nav-item">
					<a href="javascript:;" onClick={() => this.props.switchDarkMode(!useDarkMode)}>
						<i class={`fa fa-${useDarkMode ? "sun text-warning" : "moon"}`} style={{fontSize:"1.8em"}}></i>
					</a>
				</li>}
				{!onboardingInProgress && (isAdmin || (model?.siteFixed && 
					model?.salesTokens?.length > 0 && model?.salesTokens[0].attr?.directoryAccess)) && <li className="nav-item">
					<Link to="/directories"><i className="fas fa-search-dollar" style={{fontSize: "1.8em"}}></i></Link>
				</li>}
				<SidePanelToggle autoCloseOnBlur={true} overrideActiveState={notifPanelActive} showIconOnActive onClick={() =>this.setState(prevState => ({...prevState, notifPanelActive: false}))}>
					<h3>Notifications</h3><br />
					{notificationItemList("", true)}
					{!allLoaded && <Button color="primary" outline onClick={() => this.loadMoreNotifications()} className="mx-auto" style={{
						display: "block"
					}}>Load More</Button>}
				</SidePanelToggle>
				<li className="dropdown navbar-user" id="userDropdown">
					<a href="javascript:;" className="dropdown-toggle" data-toggle="dropdown">
						{avatar && <img src={avatar} />}
						{!avatar && <div className="image image-icon bg-black text-grey-darker">
							<i className="fa fa-user"></i>
						</div>}
						<span className="d-none d-md-inline">{ user?.given_name } { user?.family_name }</span> <b className="caret"></b>
					</a>
					<div className="dropdown-menu dropdown-menu-right" id="headerDropdown">
						{!onboardingInProgress && !trialExpired && <a onClick={(e) => {e.preventDefault();this.inputFileRef.current.click()}}  href="javascript:;" className="dropdown-item">Upload Avatar</a>}
						{!onboardingInProgress && (!trialExpired && showAdminScreen) && <Link to="/admin" className="dropdown-item">Administration</Link>}
						{!onboardingInProgress && (!trialExpired && showAdminScreen) && <Link to="/settings" className="dropdown-item">User Settings</Link>}
						{!onboardingInProgress && (isAdmin || (model.reseller && !model.isAffiliate)) && <Link to="/billing-management" className="dropdown-item">Billing Management</Link>}
						{!onboardingInProgress && !trialMode && <Link to="/task-manager" className="dropdown-item">Task Management</Link>}
						{!onboardingInProgress && isAdmin && <Link to="/email-activity" className="dropdown-item">Email Activity</Link>}
						{!onboardingInProgress && isAdmin && <Link to="/admin-site-upload" className="dropdown-item">Admin Site Upload</Link>}
						{onboardingInProgress && isAdmin && <a onClick={(e) => {window.location.href = "/"}}  href="javascript:;" className="dropdown-item">
							Exit Onboarding
						</a>}
						{adminSession !== null && <a onClick={(e) => {e.preventDefault(); this.props.revertToAdminSession()}}  href="javascript:;" className="dropdown-item">
							Remove Disguise
						</a>}
						<a href="javascript:;" onClick={this.logout} className="dropdown-item">Log Out</a>
					</div>
				</li>
			</ul>
		</div>
	}
}
const mapStateToProps = (state) => ({
	adminSession: state.session.adminSession,
    model: state.site.model,
	avatar: state.session.user.avatar,
	user: state.session.user,
	isAdmin: state.session.isAdmin,
	trialMode: state.session.trialMode,
	trialExpired: state.session.trialExpired,
	isAuth: isAuthenticated(state),
	metric: state.metric,
	showAdminScreen: state.session.showAdminScreen,
	notifications: state.site.model.notification?.items,
	lastEvalKey: state.site.model.notification?.lastEvalKey,
	unReadMessages: unReadNotifications(state),
	useDarkMode: state.session.useDarkMode,
	onboardingInProgress: state.session.onboardingInProgress
})

const mapDispatchToProps = (dispatch) => ({
	populateUser: (user) => dispatch(populateUser(user)),
	revertToAdminSession: () => dispatch(revertToAdminSession()),
	getNotificationsBySite: (req) => dispatch(getNotifications(req)),
	appendModel: (append) => dispatch(appendModel(append)),
	switchDarkMode: (mode) => dispatch(switchDarkMode(mode))
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Header)